import createRootReducer from './reducers/root.reducer'
import { configureStore } from '@reduxjs/toolkit'
import { logoutMiddleware } from './middlewares/logoutMiddleware'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import baseApi from './apis/base.api'

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['cart', 'assignmentsPersist', 'rubricPersist', 'authPersist', 'theme'],
}

const createStore = function () {
    const store = configureStore({
        reducer: persistReducer(persistConfig, createRootReducer()),
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({
                immutableCheck: false,
                serializableCheck: false,
            })
                .concat(baseApi.middleware)
                .concat(logoutMiddleware),
    })

    const persistor = persistStore(store)
    return { store, persistor }
}

export default createStore
